import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import {motion} from 'framer-motion';

const {FiArrowUp, FiMail} = FiIcons;

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const handleContactClick = () => {
    window.location.href = 'mailto:hey@yiksy.com';
  };

  const footerLinks = [
    {
      title: "Links",
      links: [
        {name: "Features", href: "#features"},
        {name: "How It Works", href: "#how-it-works"},
        {name: "How You Start", href: "#how-you-start"},
        {name: "Pricing", href: "#pricing"},
        {name: "FAQ", href: "#faq"}
      ]
    },
    {
      title: "Contact",
      links: [
        {name: "Email Us", href: "mailto:hey@yiksy.com", isEmail: true}
      ]
    }
  ];

  return (
    <footer className="bg-text pt-20 pb-10 relative overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-0 w-full h-full bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiNmZmYiIGZpbGwtb3BhY2l0eT0iMC4xIj48cGF0aCBkPSJNMzYgMzRjMC0yLjIgMS44LTQgNC00czQgMS44IDQgNC0xLjggNC00IDQtNC0xLjgtNC00eiIvPjwvZz48L2c+PC9zdmc+')] bg-center"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-16">
          <div>
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-12 h-12 rounded-full overflow-hidden bg-white shadow-lg border-2 border-gray-200 flex items-center justify-center">
                <img 
                  src="/logo.svg" 
                  alt="Yiksy Logo" 
                  className="w-full h-full object-contain" 
                />
              </div>
              <span className="text-2xl tracking-tight text-white">
                <span className="font-bold">Yiksy</span>
              </span>
            </div>
            <p className="text-gray-300 mb-8 max-w-md">
              Automate your social media content creation with our AI-powered platform. Save time, increase engagement, and never run out of content ideas.
            </p>
            
            {/* Contact Button */}
            <motion.button
              onClick={handleContactClick}
              className="bg-primary text-white px-6 py-3 rounded-xl font-semibold hover:bg-blue-700 transition-colors shadow-lg flex items-center group"
              whileHover={{scale: 1.05}}
              whileTap={{scale: 0.95}}
            >
              Contact Us
              <SafeIcon icon={FiMail} className="ml-2 group-hover:scale-110 transition-transform" />
            </motion.button>
          </div>

          {footerLinks.map((column, index) => (
            <div key={index}>
              <h4 className="text-white font-bold mb-6">{column.title}</h4>
              <ul className="space-y-4">
                {column.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    {link.isEmail ? (
                      <button
                        onClick={handleContactClick}
                        className="text-gray-300 hover:text-white transition-colors flex items-center group"
                      >
                        <SafeIcon icon={FiMail} className="mr-2 group-hover:scale-110 transition-transform" />
                        {link.name}
                      </button>
                    ) : (
                      <a
                        href={link.href}
                        className="text-gray-300 hover:text-white transition-colors"
                      >
                        {link.name}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-gray-700 pt-10 flex flex-col md:flex-row justify-between items-center">
          <motion.button
            onClick={scrollToTop}
            className="w-12 h-12 bg-text-light/10 rounded-full flex items-center justify-center hover:bg-primary transition-colors"
            whileHover={{scale: 1.1}}
            whileTap={{scale: 0.9}}
          >
            <SafeIcon icon={FiArrowUp} className="text-white" />
          </motion.button>
        </div>

        <div className="mt-10 text-center">
          <p className="text-gray-400 text-sm">
            © 2025 Yiksy. All rights reserved.
          </p>
          <p className="text-gray-500 text-sm mt-2">
            Invite-only beta access
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;